import { Component } from '@angular/core';

@Component({
  selector: 'browser-modal',
  templateUrl: './browser-modal.component.html',
  styleUrls: ['./browser-modal.component.css']
})
export class BrowserModalComponent {

}
